import React from 'react';
import './colors.css';

const generateRandomDateTime = () => {
  const now = new Date();
  const randomMinutes = Math.floor(Math.random() * 60);
  const randomSeconds = Math.floor(Math.random() * 60);
  now.setMinutes(now.getMinutes() - randomMinutes);
  now.setSeconds(now.getSeconds() - randomSeconds);
  return now.toISOString();
};

const UpdatesArray = [
  {
    Title: "Lorem ipsum dolor",
    Content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    Time: generateRandomDateTime(),
    Poster: "User1"
  },
  {
    Title: "Ut enim ad minim",
    Content: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    Time: generateRandomDateTime(),
    Poster: "User2"
  },
  {
    Title: "Duis aute irure",
    Content: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    Time: generateRandomDateTime(),
    Poster: "User3"
  },
  {
    Title: "Excepteur sint occaecat",
    Content: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    Time: generateRandomDateTime(),
    Poster: "User4"
  },
  {
    Title: "Sunt in culpa",
    Content: "Sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    Time: generateRandomDateTime(),
    Poster: "User5"
  }
];

const Updates = ({ visibleUsers }) => {
  const BOTTOM_TAB_HEIGHT = 65; // Height of the bottom tab

  // Log all the user IDs received from App.js
  console.log("Visible user IDs:", visibleUsers);

  return (
    <div style={{ width: '100vw', height: `calc(100vh - ${BOTTOM_TAB_HEIGHT}px)`, padding: '30px 30px 30px 10px', backgroundColor: 'var(--background-color)', color: 'var(--primary-color)', fontFamily: "'Press Start 2P', sans-serif", overflowY: 'auto' }}>
      <h1 style={{fontFamily: "'Oswald', sans-serif" }}>Updates</h1>
      {visibleUsers.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center' }}>
          {visibleUsers.map((user, index) => (
            <div key={user.id} style={{ backgroundColor: 'var(--menu-item-background-color)', padding: '20px', borderRadius: '10px', boxShadow: '0 0 10px var(--secondary-color)', width: '100%', maxWidth: '80%', color: 'var(--primary-color)', marginRight: window.innerWidth <= 768 ? '20px' : '0' }}>
              <h3 style={{ fontFamily: "'PressStart2P', sans-serif" }}>{UpdatesArray[index].Title}</h3>
              <p style={{ fontFamily: "'Oswald', sans-serif" }}>{UpdatesArray[index].Content}</p>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                <span>Posted by: {UpdatesArray[index].Poster}</span>
                <span>{new Date(UpdatesArray[index].Time).toLocaleTimeString()}</span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p style={{ color: 'var(--primary-color)', textAlign: 'center' }}>No updates found nearby</p>
      )}
    </div>
  );
};

export default Updates;